import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";
import { SESSION_QUERY_KEY } from './CheckSessionHook'

export type AddSuccessorPaymentType = {
  payment_method_uid: string; 
  successor_uuid: string;     
};

export const useAddSuccessorPayment = (
  options?: UseMutationOptions<any, Error, AddSuccessorPaymentType>
) => {
  return useMutation({
    ...options,
    mutationKey: ["addSuccessorPayment"],
    mutationFn: async (payload: AddSuccessorPaymentType) => {
      return axiosInstance
        .post("/successors/payment", payload)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Przetwarzanie płatności dla sukcesora...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "add-successor-payment",
      });

      if (options?.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      if (data?.paid === false) {
        Toast({
          message: "Sukcesor nie został opłacony. Faktura pozostaje otwarta.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "add-successor-payment",
        });
        
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
        return;
      }

      Toast({
        message: "Płatność dla sukcesora została dodana.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "add-successor-payment",
      });

      let counter = 0;
      const intervalId = setInterval(() => {
        queryClient.invalidateQueries({ queryKey: ["successors-list"] });
        counter++;
        if (counter >= 4) {
          clearInterval(intervalId);
        }
      }, 1000);

      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      if (options?.onError) {
        options.onError(error, variables, context);
      }
      Toast({
        message: "Wystąpił błąd podczas pobierania płatności za sukcesora.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "add-successor-payment",
      });
    },
  });
};

export default useAddSuccessorPayment;
